import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./home.css";

import Hero from "./hero/Hero";
import Entity from "./entity/Entity";
import News from "./news/News";
import Establishment from "./establishment/Establishment";
import Suppliers from "./suppliers/Suppliers";
import Warehouse from "./warehouse/Warehouse";
import { useEffect, useState } from "react";
import Products from "./products/Products";

import { getHome, getNews, getProducts } from "../../api/home";
import { getSuppliers } from "../../api/suppliers";
import StorageCapacity from "./storage-capacity/StorageCapacity";
import SocialResponsibility from "./social-responsibility/SocialResponsibility";
import HomeSEO from "../../components/SEO/HomeSEO";

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.screen.width < 768);
  const [data, setData] = useState({});
  const [suppliers, setsuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(window.screen.width < 768);
    });

    (async () => {
      const response = await getHome();
      const result = await response.json();

      setData(result.data[0]);
    })();

    (async () => {
      const response = await getSuppliers();
      const result = await response.json();

      setsuppliers(result.data);
    })();

    (async () => {
      const response = await getProducts();
      const result = await response.json();

      setProducts(result.data);
    })();

    (async () => {
      const response = await getNews();
      const result = await response.json();

      setNews(result.data);
    })();
  }, []);

  console.log(news);

  return (
    <>
      <HomeSEO />
      <Hero isMobile={isMobile} data={data} />

      {/* <StorageCapacity data={data} /> */}

      <Entity isMobile={isMobile} data={data} />

      {news.length !== 0 && (
        <News isMobile={isMobile} data={data} news={news} />
      )}

      <Establishment isMobile={isMobile} data={data} />

      {products.length !== 0 && (
        <Products isMobile={isMobile} data={data} products={products} />
      )}

      {/* location */}

      <Warehouse isMobile={isMobile} data={data} />

      <SocialResponsibility isMobile={isMobile} data={data} />

      {suppliers.length !== 0 && (
        <Suppliers isMobile={isMobile} suppliers={suppliers} />
      )}
    </>
  );
};

export default Home;
